import React from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import './section.scss';

type MainTextSectionProps = {
    title: React.ReactNode;
    to: string;
};

const MainTextSection = ({ title, to }: MainTextSectionProps) => (
    <li className='main-text__list-item'>
        <Typography
            variant='h6'
            component={Link}
            className='main-text__section-title'
            to={to}
            sx={{
                display: 'flex',
                alignItems: 'center',
                lineHeight: '28px',
                letterSpacing: '0',
                color: 'inherit',
                cursor: 'pointer',
                textDecoration: 'none',
            }}
        >
            <span className='main-text__marker'>
                ○
            </span>
            <span className='main-text__section-title-text'>{title}</span>
        </Typography>
    </li>
)

export default MainTextSection;
